import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatAutocompleteTrigger} from '@angular/material';
import {Observable} from 'rxjs/Observable';

import {FieldRequestParameters, RequestParameters} from '../../models/request-parameters/parameter.model';
import {UserPartner} from '../../../users/users-partner/user-partner.model';
import {UsersPartnerService} from '../../../users/users-partner/users-partner.service';
import {Organization} from '../../../organization/organization.model';
import {Agency} from '../../../agency/agency.model';
import {AgencyService} from '../../../agency/agency.service';

@Component({
  selector: 'app-users-partner-autocomplete',
  templateUrl: './users-partner-autocomplete.component.html',
  styleUrls: ['./users-partner-autocomplete.component.scss']
})
export class UsersPartnerAutocompleteComponent implements OnInit, OnChanges {

  @Input() userPartnerFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Input('organization') organization: Organization;
  @Input('setOrganizationNull') setOrganizationNull: boolean = false;
  @Input('agency') agency: Agency;
  @Output() onUserSelected: EventEmitter<UserPartner> = new EventEmitter<UserPartner>();

  @ViewChild('autoUsersPartner') autoUsersPartner: ElementRef;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;

  users: Observable<any> = new Observable<any>();
  usersLoading: boolean = true;
  usersParameters: RequestParameters;
  organizationAgencyValues: any;
  constructor(private usersPartnerService: UsersPartnerService, private agencyService: AgencyService) {
    this.agencyService.onOrganizationChangeRecieve().subscribe(
      (value) => {
        if (value) {
          this.organizationAgencyValues = value;
          this.usersParameters = new RequestParameters();
          this.usersParameters.fields.push(new FieldRequestParameters('organization', value.organizationReference));
          this.usersParameters.fields.push(new FieldRequestParameters('agency', value.agencyReference));
          this.updateUsers();
        }
      }
    );
  }

  ngOnInit() {
    if (!this.organizationAgencyValues) {
      this.usersParameters = new RequestParameters();
      
      // if (this.organization !== null && this.organization !== undefined) {
      //   this.usersParameters.fields.push(new FieldRequestParameters('organization', this.organization.reference));
      // }
      // if (this.setOrganizationNull) {
      //   this.usersParameters.fields.push(new FieldRequestParameters('organization', 'null'));
      // }
  
      if (this.agency !== null && this.agency !== undefined) {
        this.usersParameters.fields.push(new FieldRequestParameters('agency', this.organization.reference));
      }
      this.updateUsers();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.usersParameters = new RequestParameters();
    if (changes.hasOwnProperty('organization')) {
      if (this.organization !== null && this.organization !== undefined) {
        this.usersParameters.fields.push(new FieldRequestParameters('organization', this.organization.reference));
      }
    }
    if (changes.hasOwnProperty('agency')) {
      if (this.agency !== null && this.agency !== undefined) {
        this.usersParameters.fields.push(new FieldRequestParameters('agency', this.organization.reference));
      }
    }
    this.updateUsers();
  }
  onSelectUser(event) {
    const user = event && event.option ? event.option.value : this.userPartnerFormControl.value;
    this.onUserSelected.emit(user);
    // Material beta annule la fermeture si la liste d'options est recréée
    // dans le même tour. On ferme après ce cycle.
    setTimeout(() => {
      if (this.autocompleteTrigger) {
        this.autocompleteTrigger.closePanel();
      }
    });
  }

  displayUsers (user: UserPartner) {
    if (user !== null) {
      return user.username + ' -- ' + user.firstname + ' ' + user.lastname;
    }
  }

  filterUsers (filterInput: string = '') {
    if (typeof filterInput !== 'string') {
      return;
    }
    const selected = this.userPartnerFormControl ? this.userPartnerFormControl.value : null;
    if (selected && typeof selected === 'object' && filterInput === this.displayUsers(selected)) {
      return;
    }
    if (this.usersParameters.searchString !== filterInput) {
      this.usersParameters.searchString = filterInput;
      this.updateUsers();
    }
  }

  updateUsers () {
    this.usersLoading = true;
    this.users = this.usersPartnerService.getUsersPartners(this.usersParameters)
      .map(
        (response) => {
          this.usersLoading = false;
          return response.result;
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/users-partner-autocomplete/users-partner-autocomplete.component.ts